import Swiper, { Navigation, EffectFade, Autoplay, Pagination, Thumbs } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export default function () {
  new Swiper('.swiper-articles', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1.05,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 1.1,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });

  new Swiper('.swiper-related-products', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      }
    }
  });

  new Swiper('.swiper-related-products-innovation', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1.5,
    spaceBetween: 20,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });

  new Swiper('.swiper-fiber-to-fabric', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1.2,
    spaceBetween: 44,
    breakpoints: {
      450: {
        slidesPerView: 1.5,
        spaceBetween: 44
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 100
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 132
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 140
      }
    }
  });

  new Swiper('.swiper-timeline', {
    modules: [Navigation],
    centeredSlides: true,
    slideToClickedSlide: true,
    initialSlide: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1,
    breakpoints: {
      640: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 5
      },
      1280: {
        slidesPerView: 7
      }
    }
  });

  const homepageSwiperSettings = {
    modules: [Navigation, EffectFade, Autoplay],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  };

  const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!reducedMotionMediaQuery.matches) {
    homepageSwiperSettings.effect = 'fade';
    homepageSwiperSettings.loop = true;
    homepageSwiperSettings.autoplay = { delay: 3000 };
  }

  const homepageSwiper = new Swiper('.swiper-home', homepageSwiperSettings);
  const homeCarouselContainer = document.querySelector('#home-carousel');

  if (homeCarouselContainer) {
    homeCarouselContainer.addEventListener('click', () => {
      homepageSwiper.autoplay.pause();
    });
  }

  /* swiper hero */
  document.querySelectorAll('.block-heroSlider').forEach((block) => {
    const buttonPlay = block.querySelector('.swiper-hero-play');
    const buttonPause = block.querySelector('.swiper-hero-stop');

    if (!buttonPlay || !buttonPause) {
      return;
    }

    const heroSwiper = new Swiper(block.querySelector('.swiper-hero'), {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      pagination: {
        el: block.querySelector('.swiper-pagination'),
      },
      on: {
        slideChangeTransitionEnd: function () {
          const currentSlide = this.slides[this.activeIndex];
          const theme = currentSlide?.getAttribute('data-theme');
          currentSlide?.closest('.block-heroSlider')?.setAttribute('data-theme', theme);
        },
        init: function () {
          const currentSlide = this.slides[this.activeIndex];
          const theme = currentSlide?.getAttribute('data-theme');
          currentSlide?.closest('.block-heroSlider')?.setAttribute('data-theme', theme);
        }
      }
    });

    // Initial state of the PLAY/PAUSE buttons based on reduced motion preference
    if (reducedMotionMediaQuery.matches) {
      buttonPause.classList.add('!hidden');
      heroSwiper.autoplay.stop();
    } else {
      buttonPlay.classList.add('!hidden');
    }

    // Bouton PLAY
    buttonPlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.currentTarget.classList.add('!hidden');
      buttonPause.classList.remove('!hidden');
      heroSwiper.autoplay.start();
    });

    // Bouton PAUSE
    buttonPause.addEventListener('click', (e) => {
      e.preventDefault();
      e.currentTarget.classList.add('!hidden');
      buttonPlay.classList.remove('!hidden');
      heroSwiper.autoplay.stop();
    });
  });

  // Product detail swiper
  var swiper = new Swiper('.product-carousel-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4.2,
    freeMode: true,
    watchSlidesProgress: true
  });
  new Swiper('.product-carousel', {
    modules: [Navigation, Thumbs],
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    thumbs: {
      swiper: swiper
    }
  });
}
